import React, { useEffect, useState } from 'react';
import ModalFormVehiTypes from '../../components/forms/catalog/modal.form.vehicleTypes';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListVehicleType() {
  const [msgGet ,setMsgGet] = useState('');
  const [vehicleTypes,setvehicleTypes] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });


  useEffect(() => {
    getType();
  }, []);

  const createvehicleType = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getType();
  };

  // const editvehicleType = () => {
  //   setAlert({ show: true, message: 'Tipo Editado Correctamente' });
  //   getType();
  // };

  const editButton = (row) => {
    return (
      <ModalFormVehiTypes
        title="Modificar Tipo"
        button_text="Editar"
        button_variant="outline-primary"
        vehicleTypeSelect={row.id}
        callback={createvehicleType}
      ></ModalFormVehiTypes>
    );
  };

  const getType = async()=>{
    const responsevehicleTypes = await get('/catalog/vehicletype/',{})
    if(responsevehicleTypes.success){
      setvehicleTypes(responsevehicleTypes.data);
    }else{
      setMsgGet(responsevehicleTypes.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormVehiTypes
        title="Crear Tipo"
        button_text="Crear Tipo"
        button_variant="primary"
        callback={createvehicleType}
      ></ModalFormVehiTypes>
      <ListTables
        data={vehicleTypes}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListVehicleType;
